export { cn } from './tailwind';
export { displayDuration } from './time';
export { formatNumber } from './number';
export { getInitials } from './string';

export enum LOCAL_STORAGE_ENUM {
  SHOW_INSTRUCTION = 'SHOW_INSTRUCTION',
}

// console.log(getInitials("Asher Pilbrow"));   "AP"
// console.log(getInitials("Asher"));            "A"
export function getInitialName(name: string) {
  const nameParts = name.split(' ');
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  } else {
    const firstInitial = nameParts[0].charAt(0).toUpperCase();
    const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  }
}

export const getNetworkInfo = () => {
  if (!navigator.connection) return 'Unknown';

  return {
    effectiveType: navigator.connection.effectiveType,
    downlink: navigator.connection.downlink,
    rtt: navigator.connection.rtt,
    saveData: navigator.connection.saveData,
  };
};

export const flattenNestedObject = <T>(obj: Record<string, Record<string, T>>): T[] => {
  return Object.values(obj).flatMap((innerObj) => Object.values(innerObj));
};

export const shuffleArray = <T>(array: T[]): T[] => {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
};

export function kebabToTitleCase(str: string): string {
  return str
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function titleCaseToKebabCase(str: string): string {
  return str
    .split(' ')
    .map((word) => word.toLowerCase())
    .join('-');
}
